module.exports = __webpack_public_path__ + "static/media/browserIcon.58566a05.svg";